/**token购买弹框 */
<template>
  <el-dialog
    v-model="DLGVisible"
    :title="DLGTitle"
    :before-close="closeDLG"
    width="787"
    append-to-body
    modal-class="token-purchase-dialog purchase-dialog"
  >
    <div class="purchase-container">
      <div class="purchase-card">
        <TokenPurchaseCards
          v-model:value="activeDiscountId"
          :data="discountInfo"
        />
      </div>
      <div class="price">
        <div class="price-number">
          <span class="icon">￥</span>
          <span class="number">
            {{ activeDiscountItem.purchasePrice }}
          </span>
        </div>
        <div class="price-tag" v-if="activeDiscountItem.originalPrice">
          已享受9折福利 已减6元
        </div>
      </div>
      <div class="purchase-button">
        <el-button type="primary" class="button" @click="createOrder">
          立即支付
        </el-button>
        <span class="tip">
          注意: 支付订单则表示同意
          <a @click="goAgreement">《锐研用户付费协议》</a>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  nextTick,
  defineExpose,
  computed,
  defineEmits,
  defineProps,
  watch,
} from "vue";
import { httpPost } from "@/api/httpService";
import { ElMessage } from "element-plus";
import { confirmBox } from "@/utils/messageBox.js";
import TokenPurchaseCards from "./TokenPurchaseCards.vue";
import { httpAuthPost } from "@/api/httpService.js";

// 弹窗相关
const DLGVisible = ref(false);
const DLGTitle = ref("云访谈Token充值！");
const openDLG = () => {
  DLGVisible.value = true;
};
const closeDLG = () => {
  DLGVisible.value = false;
};

const discountInfo = ref([
  {
    id: 67,
    label: "80万token加油包",
    originalPrice: 59.8,
    purchasePrice: 53.8,
    unitPrice: 0.67,
    tag: "性价比之王",
  },
  {
    id: 66,
    label: "40万token加油包",
    originalPrice: null,
    purchasePrice: 29.9,
    unitPrice: 0.7,
    tag: null,
  },
  {
    id: 68,
    label: "120万token加油包",
    originalPrice: null,
    purchasePrice: 89.7,
    unitPrice: 0.7,
    tag: null,
  },
]);
const activeDiscountId = ref(67);
const activeDiscountItem = computed(() => {
  return discountInfo.value.find((item) => item.id === activeDiscountId.value);
});

//优惠方式,默认无优惠
const DISCOUNT_METHOD_TAB = {
  NORMAL_DISCOUNT: -1,
  STUDENT_DISCOUNT: 4,
  DISCOUNT_CODE: 2,
};
const discountMethod = ref(DISCOUNT_METHOD_TAB.NORMAL_DISCOUNT);
const changeDiscountMethod = () => {};

//立即支付
const createOrder = async () => {
  let params = {
    setMealId: activeDiscountId.value,
  };
  let res = await httpAuthPost("/pay/v1/createOrder", params);
  if (res.code == 0) {
    window.open("https://www.ringdata.com/pay?order=" + res.data, "_blank");
  } else {
    ElMessage.error(res.message);
  }
};

//前往用户付费协议
const goAgreement = () => {
  window.open("https://www.ringdata.com/payment_agreement", "_blank");
};

defineExpose({ openDLG, closeDLG });
</script>

<style lang="scss" scoped>
.token-purchase-dialog {
  .purchase-container {
    height: 350px;
    padding: 0 30px;
    .purchase-card {
      margin-top: 40px;
      margin-left: 15px;
    }
    .price {
      margin-top: 80px;
      margin-left: 15px;
      display: flex;
      align-items: center;
      gap: 20px;
      .price-number {
        color: #ff2e4a;
        font-size: 40px;
        font-weight: 550;
        .icon {
          font-size: 20px;
          margin-right: 10px;
        }
      }
      .price-tag {
        height: 28px;
        line-height: 28px;
        border-radius: 5px;
        text-align: center;
        background-color: #fff6e6;
        color: #e4af55;
        font-size: 13px;
        padding: 0 10px;
      }
    }
    .purchase-button {
      margin-top: 20px;
      margin-left: 15px;
      display: flex;
      align-items: center;
      gap: 30px;
      .button {
        width: 150px;
        height: 40px;
        border-radius: 4px;
        border: none;
        background: linear-gradient(
          133.92deg,
          rgba(88, 88, 88, 1) 6.76%,
          rgba(16, 16, 16, 1) 99.94%
        );
        color: rgba(255, 255, 255, 1);
      }
      .tip {
        color: rgba(188, 188, 188, 1);
        font-size: 12px;
        a {
          color: #585858;
        }
        a:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
